<script>
import { debounce } from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import { formatJustificativasResponse, prepareSaveData, prepareSaveDataMateriais } from "./utils/formatters.js";
import { BeneficiosEnum } from "@/core/enums/beneficios";
import { contarErrosProjeto } from "@/core/utils/validacoesJustificativas";
import formpdJustificativasService from "@/api/formpd/formpdJustificativas.service";
import FormModal from "@/components/form-modal.vue";
import MonthlyFilter from "@/components/monthly-filter.vue";
import QueueDialog from "@/components/queue-dialog.vue";
import ResumoPendenciasJustificativas from "@/components/resumo-pendencias-justificativas.vue";
import TableColaboradores from "./components/TableColaboradores.vue";
import TableTerceiros from "./components/TableTerceiros.vue";
import TableMateriaisLB from "./components/TableMateriaisLB.vue";
import ModalNotas from "./components/ModalNotas.vue";
import ModalAtividades from "./components/ModalAtividades.vue";

const tipoEnum = {
  COLABORADORES: "colaboradores",
  SERVICOS_TERCEIROS: "servicos-terceiros",
  MATERIAIS_LB: "materiais-lb",
};
const tipoRelatorioEnum = {
  COLABORADORES: "justificativa-colaboradores-por-projetos",
  SERVICOS_TERCEIROS: "justificativa-terceiros-lb-por-projetos",
  MATERIAIS_LB: "justificativa-materiais-lb-por-projetos",
};
const tipoRelatorioImportEnum = {
  COLABORADORES: "colaboradores",
  SERVICOS_TERCEIROS: "terceiros",
  MATERIAIS_LB: "materiais-lb",
};

const opcoesEscolaridadeLB = [
  "graduado",
  "técnico de nível médio",
  "pós-graduado",
  "doutor",
  "mestre",
  "apoio técnico",
  "tecnólogo",
];

const opcoesEnquadramentosEmpresas = [
  "Registro e Manutenção de Marcas, Patentes e Cultivares",
  "Fornecedor de Materiais",
];

export default {
  components: {
    FormModal,
    MonthlyFilter,
    QueueDialog,
    ResumoPendenciasJustificativas,
    TableColaboradores,
    TableTerceiros,
    TableMateriaisLB,
    ModalNotas,
    ModalAtividades,
  },
  data: function () {
    return {
      debouncedLoad: () => {},
      projetos: [],
      somenteErros: false,
      contextoModal: "",
      /** @type {('colaboradores' | 'servicos-terceiros')} */
      tipoSelecionado: "colaboradores",
      tipos: [
        { label: "Colaboradores", id: tipoEnum.COLABORADORES },
        { label: "Serviços terceiros", id: tipoEnum.SERVICOS_TERCEIROS },
      ],
      isVisibleUploadFile: false,
      uploadFileData: {},
      tipoEnum: tipoEnum,
      isVisibleQueueDialog: false,
      selectedNotas: [],
      modalNotas: false,
      modalAtividades: false,
      selectedAtividades: [],
      selectedRow: {},
      modalJustificativa: false,
      modalJustificativaAgrupamento: false,
      modalAnexoComprobatorio: false,
      dataAnexoComprobatorio: {},
      opts: {
        projetosAnexoComprobatorio: [],
        gruposAnexoComprobatorio: [
          { id: "universidade-inst", titulo: "Universidade / Instituição de Pesquisa" },
          { id: "inventor", titulo: "Inventor Independente" },
          { id: "me-epp", titulo: "Microempresa / Empresa de Pequeno Porte (ME/EPP)" },
          { id: "apoio-pf", titulo: "Apoio Técnico / Tec. Ind. Básica / Despesas Op. - Pessoa Física" },
          { id: "apoio-pj", titulo: "Apoio Técnico / Tec. Ind. Básica / Despesas Op. - Pessoa Jurídica" },
        ],
        selecaoProjeto: [
          {
            id: 1,
            value: "Sim",
          },
          {
            id: 2,
            value: "Não",
          },
        ],
      },
      projetosSelecionadosComprovacao: [],
      gruposSelecionadosComprovacao: [],
      isVisibleSelecaoProjetosAnexoComprobatorio: false,
      limiteJustificativaColaboradores: 3000,
      limiteJustificativaTerceiros: 1000,
      limiteFuncaoProjeto: 100,
      opcoesEscolaridadeLB,
      opcoesEnquadramentosEmpresas,
      BeneficiosEnum,
    };
  },
  created() {
    this.debouncedLoad = debounce(this.doLoad, 250);
  },
  watch: {
    clientId: function () {
      this.doLoad();
    },
  },
  computed: {
    ...mapGetters(["clientId", "intervaloCompetencia"]),
    resumoPendencias() {
      return this.projetos.map((proj, idx) => ({
        key: this.projetoKey(proj) || idx,
        label: this.projetoLabel(proj),
        qtd: contarErrosProjeto(proj, BeneficiosEnum.LEI_DO_BEM),
      }));
    },
    projetosExibidos() {
      if (!this.somenteErros) return this.projetos;
      return this.projetos.filter(
        (proj) => contarErrosProjeto(proj, BeneficiosEnum.LEI_DO_BEM) > 0,
      );
    },
    tiposDisponiveis() {
      return [
        { label: "Colaboradores", id: tipoEnum.COLABORADORES },
        { label: "Serviços terceiros", id: tipoEnum.SERVICOS_TERCEIROS },
        { label: "Materiais", id: tipoEnum.MATERIAIS_LB },
      ];
    },
    pageTitle: function () {
      let titleSuffix = "Serviços Terceiros";
      if (this.tipoSelecionado === tipoEnum.COLABORADORES)
        titleSuffix = "Colaboradores";
      if (this.tipoSelecionado === tipoEnum.MATERIAIS_LB)
        titleSuffix = "Materiais";
      return `Justificativas de ${titleSuffix} por projeto`;
    },
    relatorioXlsx: function () {
      let rows = this.projetos.reduce(
        (prev, { colaboradores, terceiros, materiais, total, projeto }) => {
          let listaExportacao = colaboradores || terceiros || materiais || [];
          let content = listaExportacao.map((item) => {
            const row = this.cols.map(({ value }) => item[value] || "");
            row.unshift(projeto.titulo || "");
            return row;
          });
          let totalRow = this.cols.map(({ value }) => total[value] || "");
          totalRow.splice(1, 0, "");
          return [...prev, ...content, totalRow];
        },
        [],
      );

      let styles = rows
        .reduce(
          (prev, row, rowIndex) => {
            const refs = [];

            if ([1, 2].includes(row.length)) {
              refs.push(rowIndex + 2);
            }

            row.forEach((cell, cellIndex) => {
              if (cell === "Total") {
                refs.push(rowIndex + 2);
              }

              if (typeof cell === "string" && cell.includes("R$ ")) {
                rows[rowIndex][cellIndex] = cell.replace("R$ ", "");
              }
            });

            return [...prev, ...refs];
          },
          [1],
        )
        .reduce(
          (acc, key) => ({
            ...acc,
            [key]: {
              font: {
                bold: true,
              },
            },
          }),
          {},
        );

      const columns = [
        {
          text: "Projeto",
          value: "projeto",
        },
        ...this.cols,
      ];

      return [
        rows,
        {
          columns,
          periodoCompetencia: this.competenciaReport,
          servico: BeneficiosEnum.LEI_DO_BEM,
          styles,
        },
      ];
    },
    competenciaReport: function () {
      let mIni = moment(this.intervaloCompetencia[0]);
      let mFim = moment(this.intervaloCompetencia[1]);
      return { ini: mIni.format("YYYY-MM"), fim: mFim.format("YYYY-MM") };
    },
    headerStyle: function () {
      return this.cols.map((h) => {
        if (h.value == "total") {
          return;
        }

        h.class = `vuetify-table-header${
          this.getClient().isClient ? "-cli" : ""
        }`;
        return h;
      });
    },
    uploadCols() {
      return [
        {
          key: "files",
          name: "Arquivo(s)",
          type: this.$fieldTypes.FILE,
          accept: ".xlsx",
          multiple: false,
        },
      ];
    },
    justificativaCols() {
      const isMateriais = this.tipoSelecionado == tipoEnum.MATERIAIS_LB;
      const options = [
        {
          key: "funcao_projeto",
          name: isMateriais ? "Descrição do Agrupamento" : "Função no projeto",
          type: this.$fieldTypes.TEXT,
          rules: [
            { rule: "required" },
            { rule: "max", params: { size: this.limiteFuncaoProjeto } },
          ],
          counter: this.limiteFuncaoProjeto,
          maxLength: this.limiteFuncaoProjeto,
          warnOnPasteTruncate: true,
          show:
            (this.tipoSelecionado == tipoEnum.COLABORADORES) || isMateriais,
        },
        {
          key: "justificativa",
          name: "Justificativa",
          type: this.$fieldTypes.TEXTAREA,
          rules: [
            { rule: "required" },
            {
              rule: "max",
              params: {
                size:
                  this.tipoSelecionado == tipoEnum.COLABORADORES
                    ? this.limiteJustificativaColaboradores
                    : this.limiteJustificativaTerceiros,
              },
            },
          ],
          counter:
            this.tipoSelecionado == tipoEnum.COLABORADORES
              ? this.limiteJustificativaColaboradores
              : this.limiteJustificativaTerceiros,
          maxLength:
            this.tipoSelecionado == tipoEnum.COLABORADORES
              ? this.limiteJustificativaColaboradores
              : this.limiteJustificativaTerceiros,
          warnOnPasteTruncate: true,
          show: true,
        },
      ];

      return options.filter(({ show }) => show);
    },
    justificativaAgrupamentoCols() {
      return [
        {
          key: "agrupamento_justificativa",
          name: "Justificativa",
          type: this.$fieldTypes.TEXTAREA,
          rules: [
            { rule: "required" },
            { rule: "max", params: { size: 4000 } },
          ],
          counter: 4000,
          maxLength: 4000,
          warnOnPasteTruncate: true,
        },
      ];
    },

    actionBarButtons() {
      const buttons = [];
      buttons.push(
        {
          text: "Atualizar",
          icon: "mdi-refresh",
          show: true,
          action: () => {
            this.doLoad();
          },
        },
        {
          text: "Gerar anexo comprobatório",
          icon: "mdi-paperclip",
          show: true,
          action: () => {
            this.projetosSelecionadosComprovacao = [];
            this.gruposSelecionadosComprovacao = [];
            this.dataAnexoComprobatorio = [];
            this.modalAnexoComprobatorio = true;
          },
        },
      );
      return buttons.filter(({ show }) => show);
    },
    anexoComprobatorioCols() {
      return [
        {
          key: "grupos",
          name: "Anexos a gerar",
          type: this.$fieldTypes.AUTOCOMPLETE_MULTIPLE,
          rel: { to: "gruposAnexoComprobatorio", key: "id", name: "titulo" },
          hint: "Deixe vazio para gerar todos os anexos com dados.",
          // Segregação por enquadramento aplica-se apenas a Serviços de Terceiros.
          hideInform: this.tipoSelecionado !== tipoEnum.SERVICOS_TERCEIROS,
        },
        {
          key: "proj_selecao",
          name: "Gerar para todos os projetos?",
          type: this.$fieldTypes.RADIO,
          outline: true,
          labelBold: true,
          defaultValue: 1,
          rules: [{ rule: "required" }],
          rel: { to: "selecaoProjeto", key: "id", name: "value" },
        },
        {
          key: "projeto_id",
          name: "Projetos",
          type: this.$fieldTypes.AUTOCOMPLETE_MULTIPLE,
          rel: { to: "projetosAnexoComprobatorio", key: "id", name: "titulo" },
          hideInform: !this.isVisibleSelecaoProjetosAnexoComprobatorio,
        },
      ];
    },
  },
  methods: {
    projetoKey(proj) {
      return proj.projeto.agrupamento_id || proj.projeto.id;
    },
    projetoLabel(proj) {
      if (proj.projeto.agrupamento_id) {
        return proj.projeto.agrupamento_titulo || proj.projeto.agrupamento_codigo;
      }
      return proj.projeto.titulo || proj.projeto.codigo;
    },
    qtdPendencias(proj) {
      return contarErrosProjeto(proj, BeneficiosEnum.LEI_DO_BEM);
    },
    scrollToProjeto(key) {
      const ref = this.$refs["projeto-" + key];
      const el = Array.isArray(ref) ? ref[0] : ref;
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    doLoad() {
      this.projetos = [];
      const competencia = {
        competenciaIni: this.intervaloCompetencia[0],
        competenciaFim: this.intervaloCompetencia[1],
      };

      formpdJustificativasService
        .getJustificativas(this.clientId, this.tipoSelecionado, competencia)
        .then((response) => {
          const formatted = formatJustificativasResponse(response);
          this.opts.projetosAnexoComprobatorio = formatted.projetosAnexoComprobatorio;
          this.projetos = formatted.projetos;

          if (this.tipoSelecionado == tipoEnum.SERVICOS_TERCEIROS) {
            this.validaCNPJDuplicadoMesmoProjeto();
          }
        });
    },
    async doSave(formData = {}, close) {
      try {
        let saveData = null;

        if (this.tipoSelecionado === tipoEnum.MATERIAIS_LB) {
          saveData = prepareSaveDataMateriais(formData, BeneficiosEnum.LEI_DO_BEM, this.intervaloCompetencia);
          // Materiais LB ainda usa a rota de batch do ProjetoController
          await this.apiResource(`/v1/projetos/${this.clientId}/justificativas/materiais/batch`).save(
            { ...saveData },
            formData.justificativa_id,
          );
        } else {
          saveData = prepareSaveData(formData, this.tipoSelecionado, tipoEnum, BeneficiosEnum.LEI_DO_BEM);
          if (formData.justificativa_id) {
            await formpdJustificativasService.updateJustificativa(this.clientId, formData.justificativa_id, saveData);
          } else {
            await formpdJustificativasService.createJustificativa(this.clientId, saveData);
          }
        }

        if (close) close();
        this.doLoad();
      } catch (error) {
        this.notify(error);
      }
    },
    saveDataAgrupamento: function (formData = {}) {
      const {
        agrupamento_justificativa_id,
        agrupamento_justificativa,
        id,
        projeto_id,
        funcao_projeto,
      } = formData;
      const isColaboradores =
        this.tipoSelecionado === tipoEnum.COLABORADORES ? true : false;
      const projeto = this.projetos.filter(
        (p) => p.projeto.id == projeto_id,
      )[0];

      return {
        model_id: id,
        model_type: isColaboradores ? "funcionarios" : "terceiros",
        projeto_id: projeto.projeto.agrupamento_id,
        justificativa: agrupamento_justificativa,
        agrupamento_justificativa: agrupamento_justificativa,
        agrupamento_justificativa_id: agrupamento_justificativa_id,
        funcao_projeto: funcao_projeto,
        trabalho: BeneficiosEnum.LEI_DO_BEM,
      };
    },
    async doSaveJustificativaAgrupamento(formData = {}, close) {
      try {
        const saveData = this.saveDataAgrupamento(formData);
        if (saveData.agrupamento_justificativa_id) {
          await formpdJustificativasService.updateJustificativa(this.clientId, saveData.agrupamento_justificativa_id, saveData);
        } else {
          await formpdJustificativasService.createJustificativa(this.clientId, saveData);
        }
        if (close) close();
        this.doLoad();
      } catch (error) {
        this.notify(error);
      }
    },
    importXlsx() {
      this.uploadFileData = {};
      this.isVisibleUploadFile = true;
    },
    relatorioJustificativaImportRequest() {
      const uploadedFile = this.$store.getters.uploadedFile;
      let tipoUpload;
      
      if (this.tipoSelecionado == tipoEnum.COLABORADORES) {
        tipoUpload = tipoRelatorioImportEnum.COLABORADORES;
      } else if (this.tipoSelecionado == tipoEnum.MATERIAIS_LB) {
        tipoUpload = tipoRelatorioImportEnum.MATERIAIS_LB;
      } else {
        tipoUpload = tipoRelatorioImportEnum.SERVICOS_TERCEIROS;
      }
      const trabalhoForce = BeneficiosEnum.LEI_DO_BEM;
      let formData = new FormData();
      formData.append("arquivo", uploadedFile);
      formData.append("tipo", tipoUpload);
      formData.append("trabalho", trabalhoForce);
      return formData;
    },
    async doImportXls() {
      try {
        const uploadRequest = this.relatorioJustificativaImportRequest();
        const result = await formpdJustificativasService.importJustificativas(this.clientId, uploadRequest);
        this.showNotification(result);
        this.isVisibleUploadFile = false;
      } catch (error) {
        // Erro genérico de importação (ex.: arquivo inválido). O limite de caracteres NÃO
        // bloqueia mais a importação — ele volta como aviso no fluxo de sucesso.
        const apiMessage = error?.response?.data?.message;
        if (apiMessage) {
          this.$notify({
            group: "geral",
            type: "error",
            title: "Importação não realizada",
            text: apiMessage,
            duration: 12000,
          });
        } else {
          this.showNotification({ error: true });
        }
      }
    },
    doEdit(row = {}) {
      this.selectedRow = row;
      this.modalJustificativa = true;
    },
    doEditAgrupamento(row = {}) {
      this.selectedRow = row;
      this.modalJustificativaAgrupamento = true;
    },
    showNotification(result) {
      if (result.error) {
        this.$notify({
          group: "geral",
          type: "error",
          text: "Erro ao importar o relatório",
          title: "Erro ao importar o relatório",
          duration: 5000,
        });
        return;
      }

      // Importação realizada, mas com textos que excedem o limite de caracteres:
      // avisa o usuário para corrigir na tela (a importação seguiu normalmente).
      if (result.limite_excedido) {
        this.$notify({
          group: "geral",
          type: "warn",
          title: "Importação realizada com avisos",
          text: result.message,
          duration: 12000,
        });
        return;
      }

      const message = "Relatório enviado para a fila de importação com sucesso, aguarde.";
      this.$notify({
        group: "geral",
        type: "success",
        text: message,
        title: message,
        duration: 5000,
      });
    },
    relatorioJustificativaRequest() {
      const { ini, fim } = this.competenciaReport;
      
      let tipoRelatorio;
      if (this.tipoSelecionado == tipoEnum.COLABORADORES) {
        tipoRelatorio = tipoRelatorioEnum.COLABORADORES;
      } else if (this.tipoSelecionado == tipoEnum.MATERIAIS_LB) {
         tipoRelatorio = tipoRelatorioEnum.MATERIAIS_LB;
      } else {
        tipoRelatorio = tipoRelatorioEnum.SERVICOS_TERCEIROS;
      }
      
      const trabalhoForce = BeneficiosEnum.LEI_DO_BEM;
      return {
        tipoRelatorio,
        competenciaIni: ini,
        competenciaFim: fim,
        trabalho: trabalhoForce,
      };
    },
    exportacaoRelatorio() {
      const relatorioRequest = this.relatorioJustificativaRequest();
      this.apiResource(`v1/clientes/${this.clientId}/exportacao`)
        .save(relatorioRequest)
        .then((result) => {
          if (!result.error) this.isVisibleQueueDialog = true;
        });
    },
    openNotasModal(notas = [], item = {}) {
      this.selectedNotas = notas;
      this.contextoModal = item.razao_social || item.nome || item.descricao || "";
      this.modalNotas = true;
    },
    openAtividadesModal(dados = [], item = {}) {
      this.selectedAtividades = dados[0].atividades || [];
      this.contextoModal = item.nome || "";
      this.modalAtividades = true;
    },
    doSaveAnexoComprobatorio() {
      const resource = this.apiResource(
        `v1/projetos/${this.clientId}/justificativas/anexoComprobatorio`,
      );
      const bodySave = this.anexoComprobatorioModel();

      this.showConfirm(
        "Gerar anexo comprobatório",
        "Deseja realmente gerar o anexo comprobatório para o(s) projeto(s) selecionado(s)?",
        () => {
          resource.save(bodySave).then((result) => {
            this.$notify({
              type: "success",
              group: "geral",
              title: "Sucesso",
              text: result.message,
            });

            this.modalAnexoComprobatorio = false;
            return true;
          });
        },
      );
    },
    doChangeAnexoComprobatorio(formData = {}) {
      this.isVisibleSelecaoProjetosAnexoComprobatorio = false;
      this.gruposSelecionadosComprovacao = formData.grupos || [];

      if (formData.proj_selecao == 2) {
        const idsSelecionados = formData.projeto_id;
        this.isVisibleSelecaoProjetosAnexoComprobatorio = true;

        if (idsSelecionados) {
          this.projetosSelecionadosComprovacao = idsSelecionados;
        }
      }
    },
    anexoComprobatorioModel() {
      let projetosSelecionados = [];
      this.projetosSelecionadosComprovacao.map((id) => {
        projetosSelecionados.push(
          this.opts.projetosAnexoComprobatorio.filter(
            (proj) => proj.id == id,
          )[0],
        );
      });
      return {
        trabalho: BeneficiosEnum.LEI_DO_BEM,
        tipo: this.tipoSelecionado,
        competenciaIni: this.intervaloCompetencia[0],
        competenciaFim: this.intervaloCompetencia[1],
        projetos: projetosSelecionados,
        grupos: this.gruposSelecionadosComprovacao,
      };
    },
    validaCNPJDuplicadoMesmoProjeto() {
      const projetos = this.projetos.map((items) => {
        return {
          projeto_id: items.projeto.id ?? items.projeto.agrupamento_id,
          terceiros: items.terceiros.map((terceiro) => {
            return {
              terceiro_id: terceiro.id,
              terceiro_cnpj: terceiro.cnpj ?? terceiro.cpf,
              terceiro_enquadramento: terceiro.enquadramento,
            };
          }),
        };
      });

      for (const projeto of projetos) {
        const cnpjMap = new Map();

        for (const t of projeto.terceiros) {
          const chave = `${t.terceiro_cnpj}_${t.terceiro_enquadramento ?? "null"}`;

          if (cnpjMap.has(chave)) {
            this.projetos.forEach((p) => {
              const projetoId = p.projeto.id ?? p.projeto.agrupamento_id;
              if (projetoId === projeto.projeto_id) {
                p.terceiros.forEach((ter) => {
                  const cnpj = ter.cnpj ?? ter.cpf;
                  const enquadramento = ter.enquadramento ?? "null";

                  const chaveAtual = `${cnpj}_${enquadramento}`;
                  if (chaveAtual === chave) {
                    ter.hasDuplicidades = true;
                  }
                });
              }
            });
          } else {
            cnpjMap.set(chave, 1);
          }
        }
      }
    },
  },
};
</script>

<template>
  <div class="content">
    <div class="header d-flex justify-content-between align-items-center">
      <div class="title ml-3">
        <h3 class="h3 mb-n2 bold">{{ pageTitle }}</h3>
        <span class="h6 mt-n2 text-gray-400">
          Revise e justifique os dispêndios alocados em cada projeto
        </span>
      </div>
      <div class="actions d-flex flex-row align-center">
        <v-btn
          v-for="(button, idx) in actionBarButtons"
          :key="'action-bar-' + idx"
          class="elevation-4 mr-2"
          :aria-label="'actionBarButtons-' + idx"
          @click="button.action"
        >
          <v-icon left>{{ button.icon }}</v-icon>
          <span style="font-size: 12px">{{ button.text }}</span>
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="elevation-4 mr-2" v-on="on" v-bind="attrs">
              <v-icon left>mdi-file-chart-outline</v-icon>
              <span style="font-size: 12px">Relatório</span>
            </v-btn>
          </template>
          <v-list style="padding: 1rem">
            <v-list-item-content>
              <v-list-item-title
                class="table-v-action-button mr-3"
                @click="exportacaoRelatorio()"
                style="font-size: 0.81rem; font-weight: 400; cursor: pointer"
              >
                <v-icon>mdi-file-export-outline</v-icon>Exportação
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title
                class="table-v-action-button mr-3"
                @click="importXlsx()"
                style="font-size: 0.81rem; font-weight: 400; cursor: pointer"
              >
                <v-icon>mdi-file-import-outline</v-icon>Importação
              </v-list-item-title>
            </v-list-item-content>
          </v-list>
        </v-menu>
      </div>
    </div>

    <div class="d-flex align-center mt-3 mb-2 ml-3">
      <v-select
        v-model="tipoSelecionado"
        prependIcon="mdi-format-list-bulleted-type"
        class="mr-3 pa-0 mb-0 mt-0"
        hide-details
        :items="tiposDisponiveis"
        itemText="label"
        itemValue="id"
        prefix="Tipo:"
        style="max-width: 270px"
        @change="debouncedLoad()"
      >
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title style="font-size: 0.81rem; font-weight: 500">
              {{ item.label }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-select>
      <MonthlyFilter
        style="min-width: 270px"
        @change="debouncedLoad()"
      ></MonthlyFilter>
      <v-switch
        v-model="somenteErros"
        label="Somente pendências"
        hide-details
        class="ml-3 mt-0 pt-0"
        data-testid="switch-somente-pendencias"
      ></v-switch>
    </div>

    <ResumoPendenciasJustificativas
      v-if="projetos.length"
      class="mb-3"
      :itens="resumoPendencias"
      @navegar="scrollToProjeto"
    />

    <div class="body">
      <div
        v-if="!projetos.length"
        class="teros-elevation rounded white font-weight-bold d-block pa-3 text-center"
      >
        <span> Nenhum projeto retornado para os filtros selecionados. </span>
      </div>
      <div
        v-for="(proj, idx) in projetosExibidos"
        :key="idx + 'projeto'"
        :ref="'projeto-' + (projetoKey(proj) || idx)"
        class="projeto-card teros-elevation rounded white"
        :class="{ 'mt-6': idx != 0 }"
        data-testid="card-projeto"
      >
      <div
        class="projeto-header d-flex align-center justify-space-between px-4 py-2"
        data-testid="cabecalho-projeto"
      >
        <div class="d-flex align-center">
          <v-icon class="mr-3" color="#1E88E5">
            {{ proj.projeto.agrupamento_id ? "mdi-folder-multiple-outline" : "mdi-folder-outline" }}
          </v-icon>
          <div>
            <div class="projeto-header-titulo">
              {{ (proj.projeto.agrupamento_id ? proj.projeto.agrupamento_titulo : proj.projeto.titulo) || "Sem título" }}
            </div>
            <div class="projeto-header-meta">
              {{ proj.projeto.agrupamento_id ? "Projeto" : "Iniciativa" }}
              · Código: {{ (proj.projeto.agrupamento_id ? proj.projeto.agrupamento_codigo : proj.projeto.codigo) || "Sem código" }}
              · Ano-base: {{ (proj.projeto.agrupamento_id ? proj.projeto.agrupamento_anobase : proj.projeto.anoBase) || "Sem Ano-base" }}
            </div>
          </div>
        </div>
        <v-chip
          v-if="qtdPendencias(proj)"
          small
          outlined
          color="error"
          class="ml-2 font-weight-bold flex-shrink-0"
          data-testid="badge-pendencias-projeto"
        >
          <v-icon left small>mdi-alert-circle-outline</v-icon>
          {{ qtdPendencias(proj) }} {{ qtdPendencias(proj) === 1 ? "pendência" : "pendências" }}
        </v-chip>
        <v-chip
          v-else
          small
          outlined
          color="success"
          class="ml-2 flex-shrink-0"
          data-testid="badge-sem-pendencias-projeto"
        >
          <v-icon left small>mdi-check</v-icon>
          Sem pendências
        </v-chip>
      </div>
      <template v-if="tipoSelecionado === tipoEnum.COLABORADORES">
        <TableColaboradores
          :key="'colaboradores-' + (proj.projeto.agrupamento_id || proj.projeto.id || idx)"
          :projetoWrapper="proj"
          :trabalho="BeneficiosEnum.LEI_DO_BEM"
          :somenteErros="somenteErros"
          @edit="doEdit"
          @open-atividades="openAtividadesModal"
        />
      </template>
      <template v-else-if="tipoSelecionado === tipoEnum.SERVICOS_TERCEIROS">
        <TableTerceiros
          :key="'terceiros-' + (proj.projeto.agrupamento_id || proj.projeto.id || idx)"
          :projetoWrapper="proj"
          :trabalho="BeneficiosEnum.LEI_DO_BEM"
          :somenteErros="somenteErros"
          @edit="doEdit"
          @open-notas="openNotasModal"
        />
      </template>
      <template v-else-if="tipoSelecionado === tipoEnum.MATERIAIS_LB">
        <TableMateriaisLB
          :key="'materiais-lb-' + (proj.projeto.agrupamento_id || proj.projeto.id || idx)"
          :projetoWrapper="proj"
          :trabalho="BeneficiosEnum.LEI_DO_BEM"
          :somenteErros="somenteErros"
          @edit="doEdit"
          @open-notas="openNotasModal"
        />
      </template>
      </div>
    </div>

    <FormModal
      title="Editar justificativa"
      :cols="justificativaCols"
      :opened.sync="modalJustificativa"
      :value.sync="selectedRow"
      @save="doSave"
    ></FormModal>

    <FormModal
      title="Editar justificativa agrupamento"
      :cols="justificativaAgrupamentoCols"
      :opened.sync="modalJustificativaAgrupamento"
      :value.sync="selectedRow"
      @save="doSaveJustificativaAgrupamento"
    ></FormModal>

    <FormModal
      title="Importação justificativa"
      :cols="uploadCols"
      :opened.sync="isVisibleUploadFile"
      :value.sync="uploadFileData"
      @save="doImportXls()"
    ></FormModal>

    <ModalNotas
      :opened.sync="modalNotas"
      :notas="selectedNotas"
      :contexto="contextoModal"
    />

    <ModalAtividades
      :opened.sync="modalAtividades"
      :atividades="selectedAtividades"
      :contexto="contextoModal"
    />

    <QueueDialog
      :opened.sync="isVisibleQueueDialog"
      title="Exportação justificativas"
      appendTitleIcon="mdi-file-chart-outline"
    ></QueueDialog>

    <FormModal
      title="Gerar anexo comprobatório"
      :cols="anexoComprobatorioCols"
      :opened.sync="modalAnexoComprobatorio"
      :value.sync="dataAnexoComprobatorio"
      :opts="opts"
      @save="doSaveAnexoComprobatorio"
      @update:value="doChangeAnexoComprobatorio"
    ></FormModal>
  </div>
</template>

<style lang="scss" scoped>
.notas-table-v {
  min-width: 500px;

  .v-data-table__wrapper {
    height: unset !important;
  }
}

.projeto-card {
  overflow: hidden;
}

.projeto-header {
  background-color: #f5f7fa;
  border-left: 4px solid #1e88e5;
}

.projeto-header-titulo {
  font-weight: 600;
  font-size: 0.95rem;
  color: #1c1c44;
}

.projeto-header-meta {
  font-size: 0.75rem;
  color: #757575;
}
</style>
